import { GreenhouseCustomFieldId, GreenhouseJob } from './greenhouse';
import { slugify } from '@/utils/formatters';

export const getJobsByGreenhouseField = (jobs: GreenhouseJob[], fieldId: GreenhouseCustomFieldId) => {
  return jobs.filter(job => job.metadata?.find(metadata => metadata.id === fieldId)?.value === true);
};

export const getJobTeam = (job: GreenhouseJob): string => {
  const value = job.metadata?.find(metadata => metadata.id === GreenhouseCustomFieldId.Team)?.value;
  return typeof value === 'string' && value.length > 0 ? value : 'Team TBD';
};

export const getJobUrl = (job: GreenhouseJob): string => {
  const lang = job.language ?? 'en';
  return `/${lang}/jobs/${job.id}/${slugify(job.title)}`;
};
